import { useQuery } from "@tanstack/react-query";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import {
  AGENCY_EMPLOYEE_LIST_QUERY_KEY,
  AGENCY_LIST_QUERY_KEY,
} from "../constants/querykeys";
import { BackednResponse, IBrand } from "@shared/lib/types";
import { Agency } from "@shared/lib/types/agency";

export function useGetAgency(brandId: string) {
  const { data, isLoading, isError, error } = useQuery<BackednResponse<Agency>>(
    {
      queryKey: [...AGENCY_LIST_QUERY_KEY, brandId],
      queryFn: () => AgencyService.getAgencyById(brandId),
      enabled: !!brandId,
    }
  );

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    agency: data?.data,
    isError,
    isFetching: isLoading,
  };
}
